export const DEFAULT_REDO_OVERLAY_Z_INDEX = 1000000;
export const MODAL_REDO_OVERLAY_Z_INDEX = 1000001;
export const POPPER_REDO_OVERLAY_Z_INDEX = 1000002;
